export * from './anniversary-dice.component';
